/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const resetPasswordInputDataSchema = z.object({
	token: z.string(),
	newPassword: z.string(),
})

export type ResetPasswordInputDataSchema = z.infer<typeof resetPasswordInputDataSchema>
